import { useCallback, useMemo, useState } from "react";
import { IAlert } from "~/types/alert";
import { notification } from "antd";
import { getNotificationHistory } from "~/services/notificationHistory";

export const useNotificationHistory = () => {
  const [notifications, setNotifications] = useState<IAlert[]>([]);
  const [notificationsLoading, setNotificationsLoading] = useState(false);

  const fetchNotifications = useCallback(async () => {
    try {
      setNotificationsLoading(true);
      const result = await getNotificationHistory();

      setNotifications(result || []);
      return result;
    } catch (error) {
      notification.error({
        message: "Error",
        description: "Failed to fetch notifications",
      });
      return [];
    } finally {
      setNotificationsLoading(false);
    }
  }, []);

  return useMemo(
    () => ({
      notifications,
      notificationsLoading,
      fetchNotifications,
    }),
    [notifications, notificationsLoading, fetchNotifications],
  );
};
